import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app.config';
import { BOWIUser } from '../models/BowiUser';
import { RiaLogin } from '../models/RiaLogin';
import { AppConfig } from '../models/app.config';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly userUrl: string = "User/";
  config: AppConfig;

  constructor(private apiService: ApiService, @Inject(APP_CONFIG) config: AppConfig) {
    this.config = config;
  }

  public GetRiaLogin(riaId: number): Observable<RiaLogin[]> {
    const params = new HttpParams()
      .set("riaID", riaId);
    return this.apiService.get<RiaLogin[]>(`${this.userUrl}GetRiaLogin`, params);
  }

  public GetBowiUser(iBowiId: number): Observable<BOWIUser[]> {
    const params = new HttpParams()
      .set("iBowiId", iBowiId);
    return this.apiService.get<BOWIUser[]>(`${this.userUrl}GetBowiUser`, params);
  }

  public GetRiaId(fdcn: number): Observable<number> {
    const params = new HttpParams()
      .set("fdcn", fdcn);
    return this.apiService.get<number>(`${this.userUrl}GetRiaId`, params);
  }
}
